'use strict';

/**
 * Email Obfuscation (EMO) decoder.
 *
 * Decrypts email addresses that were obfuscated by the ProcessWire
 * EmailObfuscation module. Reads the encryption key from the global
 * `config.emoKey` variable set in the PHP header.
 *
 * Original: https://github.com/BlowbackAgency/EmailObfuscation
 * License: MIT
 */

/* global config */

const cache = {};

export default function emo() {
    const key = config?.emoKey;
    if (!key) return;

    const elements = document.querySelectorAll('[data-emo]');
    if (!elements.length) return;

    elements.forEach((el) => {
        const hash = el.getAttribute('data-emo');
        const decrypted = decrypt(hash, key);

        // Replace the <noscript> element with the decrypted HTML
        const wrapper = document.createElement('span');
        wrapper.innerHTML = decrypted;

        // Replace element with its decoded contents
        while (wrapper.firstChild) {
            el.parentNode.insertBefore(wrapper.firstChild, el);
        }
        el.remove();
    });
}

function decrypt(hash, key) {
    if (cache[hash]) return cache[hash];

    let out = '';
    for (let i = 0; i < hash.length; ) {
        const e1 = key.indexOf(hash.charAt(i++));
        const e2 = key.indexOf(hash.charAt(i++));
        const e3 = key.indexOf(hash.charAt(i++));
        const e4 = key.indexOf(hash.charAt(i++));

        const c1 = (e1 << 2) + (e2 >> 4);
        const c2 = ((e2 & 15) << 4) + (e3 >> 2);
        const c3 = ((e3 & 3) << 6) + e4;

        out += String.fromCharCode(c1);
        if (e3 !== 64) out += String.fromCharCode(c2);
        if (e4 !== 64) out += String.fromCharCode(c3);
    }

    // Clean null bytes (from UTF-16 encoded content)
    if (out.includes('\x00')) {
        out = out.replaceAll('<\x00', '').replaceAll('\x00', '');
    }

    cache[hash] = decodeURIComponent(escape(out));
    return cache[hash];
}
